import _ from "lodash";
import posthog from "posthog-js";

import { APP_IDENTITY, WEB_CONFIG } from "config/app";
import { isValidString } from "utils/misc";
import Logger from "../../utils/logger";
import CurrentSession from "data/userSession";

class AnalyticsWrapper {
  constructor() {
    this.authenticatedUser = null;
    this.lastHoverMarkerTracked = null;
  }

  get baseJson() {
    const data = {
      inDemoMode: CurrentSession.inDemoMode,
    };
    if (!CurrentSession.inDemoMode) {
      data.supporter = CurrentSession.user.supporter;
    }
    return _.cloneDeep(data);
  }

  event(name, params) {
    this.setUserID();

    Logger.debug(`[FS-A] Event: ${name}`);
    this.track(name, params);
  }

  linkClicked(key, link) {
    this.setUserID();

    Logger.debug(`[FS-A] External link clicked: ${key}`);
    this.track("click_link", { title: key, link: link });
  }

  pageView() {
    this.setUserID();

    let page = _.replace(window.location.pathname, "/", "");
    if (!isValidString(page)) {
      page = WEB_CONFIG.defaultRoute;
    }
    Logger.debug(`[FS-A] Page View: ${page}`);
    this.track("view_page", {
      page: page,
      fullUrl: window.location.href,
    });
  }

  setUserID() {
    if (this.authenticatedUser) return;

    const username = _.get(CurrentSession, "user.name");
    if (!isValidString(username)) return;

    this.authenticatedUser = username;
    Logger.debug(`[FS-A] Setting user ID: ${username}`);
    posthog.identify(username);
  }

  throttleChartHover(event, params, key) {
    if (key === this.lastHoverMarkerTracked) {
      return;
    }
    this.lastHoverMarkerTracked = key;
    this.event(event, params);
  }

  track(event, params) {
    const uid = _.get(CurrentSession.firebaseUser, "uid");
    const data = _.omit({ ...this.baseJson, ...params }, ["inDemoMode"]);
    if (Logger.inDebugMode() || uid === APP_IDENTITY.demoUserId) {
      Logger.debug(data);
      return;
    }
    posthog.capture(event, data);
  }
}

const AnalyticsService = new AnalyticsWrapper();
export default AnalyticsService;
